'use strict';

module.exports = {
    init: function() {
        var urlParams = new URLSearchParams(window.location.search);
        var sessionError = urlParams.get('SessionError');
        if (sessionError) {
            window.closeGlobalErrorModal = this.closeGlobalErrorModal;
            this.triggerGlobalErrorModal({ error: window.globalErrorMsgs.sessionError, continue: window.globalErrorMsgs.continue });
        }
    },
    /**
     * closes modal and removed querystring from URL
     */
    closeGlobalErrorModal: function() {
        window.history.replaceState({}, document.title, '/' + window.location.href.substring(window.location.href.lastIndexOf('/') + 1).split('?')[0]);
        $('#globalErrorModal').modal('hide');
    },

    /**
     * Sets up and opens global error msg modal
     * @param {Object} data - data.error is the msg string
     */
    triggerGlobalErrorModal: function(data) {
        if ($('#globalErrorModal').length > 0) {
            $('#globalErrorModal').remove();
        }

        var htmlString = '<!-- Modal -->'
            + '<div class="modal fade" id="globalErrorModal" tabindex="-1" role="dialog">'
            + '<div class="modal-dialog">'
            + '<!-- Modal content-->'
            + '<div class="modal-content">'
            + '<div class="modal-header"></div>'
            + '<div class="modal-body">'
            + '<div class="d-flex justify-content-between align-items-center">' + data.error;
        if (data.continue) {
            htmlString += ' <button class="btn btn-primary hp-button" onClick="window.closeGlobalErrorModal(); return false;">' + data.continue + '</button>';
        }
        htmlString += '</div>'
            + '<div class="modal-footer"></div>'
            + '</div>'
            + '</div>'
            + '</div>';
        $('body').append(htmlString);

        $('#globalErrorModal').modal('show');
    }
};
